import { Component } from 'preact';

export default class WistiaVideo extends Component {

		constructor(props) {
			super(props);
			this.state = { foo: null};
		}

		componentWillMount() {
			let {data} = this.props
			let wistiaVidId = data && data.wistiaVidId
			const script1 = document.createElement("script");
			const script2 = document.createElement("script");

			script1.src = "https://fast.wistia.com/embed/medias/" + wistiaVidId + ".jsonp";
			script1.async = true;

			script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
			script2.async = true;

			document.body.appendChild(script1);
			document.body.appendChild(script2);
		}

		render(){

		let {data} = this.props
		let wistiaVidId = data && data.wistiaVidId

		if (!wistiaVidId){
			return null
		}

		//let imgSrc = "https://fast.wistia.com/embed/medias/" + wistiaVidId + "/swatch"
		//let vidClass = "wistia_embed wistia_async_" + wistiaVidId + " videoFoam=true"
		let vidClass = "wistia_embed wistia_async_" + wistiaVidId + " seo=false videoFoam=true"

		//make 12 if no data default to xs. if no xs then it will be 12
		let xs = data && data.xs ? data.xs : '12'
		let sm = data && data.sm ? data.sm : xs
		let md = data && data.md ? data.md : sm
		let lg = data && data.lg ? data.lg : md
		let className= 'col-xs-'+ xs + ' col-sm-'+ sm + ' col-md-'+ md + ' col-lg-'+ lg + ' '

		let fixedHeight = this.props.fixedHeight ? this.props.fixedHeight : null

		if (fixedHeight){

		//find your max width
		let aspectRatio = 16/9 // witdth / height
		let width = fixedHeight * aspectRatio
		width = Math.round(width)

		let innerWidth = window.innerWidth

		let wrapperDivWidth = innerWidth < width ? '100%' :  width + 'px'

			return (
				<div id={data.richId} className={className}>
					<div class="wistia_responsive_padding" style={{  position: 'relative', height: fixedHeight + 'px',display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
						<div class="wistia_responsive_wrapper" style={{ height: fixedHeight + 'px', width: wrapperDivWidth, maxWidth: '100%'}}>
							<div className={vidClass} style={{height: '100%', width: '100%'}} >&nbsp;
							</div>
						</div>
					</div>
				</div>
			)
		}

		return(
			<div id={data.richId} className={className} >
				<div className="wistia_responsive_padding" style={{ padding:'56.25% 0 0 0', position: 'relative'}}>
					<div className="wistia_responsive_wrapper" style={{ height: '100%', left:0, position: 'absolute', top:0, width: '100%'}}>
						<div className={vidClass} style={{height:'100%', width: '100%'}}>&nbsp;
						</div>
					</div>
				</div>
			</div>
    )

	}


}



// WEBPACK FOOTER //
// ./components/contentTypes/video/wistiaVideo.js